import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { provide } from 'vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
export default {
  __name: 'App',
  setup(__props) {
    let moveX = 0;
    let moveY = 0;
    document.onmousemove = e => {
      moveX = e.clientX;
      moveY = e.clientY;
    };
    window["dragEnd"] = (e, floatDiv) => {
      let disX = e.clientX - floatDiv.offsetLeft;
      let disY = e.clientY - floatDiv.offsetTop;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        floatDiv.style.left = left + 'px';
        floatDiv.style.top = top + 'px';
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
    const getMoveXY = callback => {
      document.onmousemove = e => {
        moveX = e.clientX;
        moveY = e.clientY;
        callback(moveX, moveY);
      };
    };
    provide('movexy', {
      getMoveXY
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};